import { render, staticRenderFns } from "./quizanswers.vue?vue&type=template&id=1e633d2d&scoped=true&"
import script from "./quizanswers.vue?vue&type=script&lang=js&"
export * from "./quizanswers.vue?vue&type=script&lang=js&"
import style0 from "./quizanswers.vue?vue&type=style&index=0&id=1e633d2d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e633d2d",
  null
  
)

export default component.exports